<template>
  <div class="vd_fav">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane name="first">
        <span slot="label">
          <i class="el-icon-date"></i>视频
        </span>
        <VideoFar :activeName="activeName" />
      </el-tab-pane>
      <!-- <el-tab-pane name="second">
        <span slot="label">
          <i class="el-icon-date"></i>专题
        </span>
        <Topics />
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import VideoFar from "./fartabpane/videofar.vue";
import Topics from "./fartabpane/topics.vue"
export default {
  components: {
    VideoFar,
    Topics
  },
  data: function() {
    return {
      activeName: "first"
    };
  },
  methods: {
    handleClick: function() {}
  },
  mounted: function() {}
};
</script>

<style lang="scss">
@media screen and (min-width: 1200px) {
  .vd_fav {
    // border: 1px solid #ccc;
  }
  .vd_fav .el-tabs__header {
    //  height: 50px;
    //  line-height: 50px;
  }
  .vd_fav .el-tabs__content {
    min-height: 400px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/personalcenter/common/favorite.vue